var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvantagesIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0384 0H0V40.0387C0 62.1511 17.9255 80.0772 40.0384 80.0772C62.1514 80.0772 80.0775 62.1514 80.0775 40.0387C80.0775 17.9261 62.1511 0 40.0384 0Z",
    fill: "#DD4741"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0387 4.44824H4.44922V40.038C4.44922 59.6936 20.3831 75.6278 40.0387 75.6278C59.6949 75.6278 75.6288 59.6936 75.6288 40.038C75.6288 20.3824 59.6949 4.44824 40.0387 4.44824Z",
    fill: "#EC797C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.0387 4.44824H4.44922V40.038C4.44922 59.6936 20.3831 75.6278 40.0387 75.6278C59.6949 75.6278 75.6288 59.6936 75.6288 40.038C75.6288 20.3824 59.6949 4.44824 40.0387 4.44824Z",
    fill: "url(#paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1289 57.835V58.7572C16.1289 59.2666 16.5413 59.6796 17.0511 59.6796H21.7452C21.6344 59.0698 21.6344 58.4448 21.7452 57.835H16.1289Z",
    fill: "#911004"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1949 62.4455C29.2323 62.4455 30.884 60.7938 30.884 58.7564C30.884 56.719 29.2323 55.0674 27.1949 55.0674C25.1575 55.0674 23.5059 56.719 23.5059 58.7564C23.5059 60.7938 25.1575 62.4455 27.1949 62.4455Z",
    fill: "#911004"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2727 18.1792H29.9618V14.4905C29.9618 12.4534 28.3101 10.8018 26.2727 10.8018C24.2353 10.8018 22.584 12.4534 22.584 14.4905C22.584 16.5276 24.235 18.1792 26.2727 18.1792Z",
    fill: "#911004"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7066 62.4455C58.7441 62.4455 60.3957 60.7938 60.3957 58.7564C60.3957 56.719 58.7441 55.0674 56.7066 55.0674C54.6692 55.0674 53.0176 56.719 53.0176 58.7564C53.0176 60.7938 54.6692 62.4455 56.7066 62.4455Z",
    fill: "#911004"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6455 57.835C32.7563 58.4448 32.7563 59.0698 32.6455 59.6796H51.2562C51.1451 59.0698 51.1451 58.4448 51.2562 57.835H32.6455Z",
    fill: "#911004"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4838 20.0244H35.4951V27.4025H47.4838V20.0244Z",
    fill: "#911004"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.095 45.8462H58.0525L56.4015 42.1292C55.6588 40.466 54.0088 39.3938 52.187 39.3906H51.1729V44.924C51.1732 45.4331 51.5859 45.8462 52.095 45.8462Z",
    fill: "#911004"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1566 59.6796H65.0063C65.5157 59.6796 65.9285 59.2666 65.9285 58.7572V57.835H62.1562C62.2674 58.4451 62.2674 59.0698 62.1566 59.6796Z",
    fill: "#911004"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2729 29.2451H16.1289V49.5341H26.2729V29.2451Z",
    fill: "#911004"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6394 29.2451H35.4951V49.5341H45.6394V29.2451Z",
    fill: "#911004"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1848 14.4915C39.1848 12.4544 37.5328 10.8027 35.4957 10.8027C33.4583 10.8027 31.8066 12.4544 31.8066 14.4915V18.1802H35.4957C37.5331 18.1799 39.1848 16.5286 39.1848 14.4915Z",
    fill: "#911004"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2729 20.0244H14.2842V27.4025H26.2729V20.0244Z",
    fill: "#911004"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6516 20.0244H28.1182V49.5356H33.6516V20.0244Z",
    fill: "#911004"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2202 51.3241C63.2202 50.3429 63.8561 49.5121 64.7378 49.2164C63.8941 48.2813 62.6766 47.6906 61.3178 47.6906H52.0953C50.5692 47.6856 49.3331 46.4498 49.3288 44.9241V39.3906H47.4844V51.3793H14.2842V55.99H22.409C23.9313 53.3464 27.3081 52.4381 29.9516 53.9601C30.7953 54.4456 31.4956 55.1462 31.9815 55.99H47.4844H49.874H51.9202C53.4428 53.3464 56.8192 52.4381 59.4628 53.9601C60.3065 54.4456 61.007 55.1462 61.4929 55.99H65.929V53.494C65.773 53.5285 65.6111 53.5483 65.4447 53.5483C64.2159 53.5483 63.2202 52.5526 63.2202 51.3241Z",
    fill: "#911004"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3708 52.5023C66.0642 52.5023 66.6263 51.9401 66.6263 51.2467C66.6263 50.5533 66.0642 49.9912 65.3708 49.9912C64.6774 49.9912 64.1152 50.5533 64.1152 51.2467C64.1152 51.9401 64.6774 52.5023 65.3708 52.5023Z",
    fill: "#911004"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.501 57.208V58.1302C15.501 58.6396 15.9134 59.0527 16.4232 59.0527H21.1173C21.0065 58.4428 21.0065 57.8179 21.1173 57.208H15.501Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.567 61.8195C28.6044 61.8195 30.256 60.1679 30.256 58.1305C30.256 56.093 28.6044 54.4414 26.567 54.4414C24.5296 54.4414 22.8779 56.093 22.8779 58.1305C22.8779 60.1679 24.5296 61.8195 26.567 61.8195Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6458 17.5513H29.3348V13.8626C29.3348 11.8255 27.6832 10.1738 25.6458 10.1738C23.6083 10.1738 21.957 11.8255 21.957 13.8626C21.957 15.8997 23.608 17.5513 25.6458 17.5513Z",
    fill: "#D1DA5B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0787 61.8195C58.1161 61.8195 59.7677 60.1679 59.7677 58.1305C59.7677 56.093 58.1161 54.4414 56.0787 54.4414C54.0413 54.4414 52.3896 56.093 52.3896 58.1305C52.3896 60.1679 54.0413 61.8195 56.0787 61.8195Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0176 57.208C32.1284 57.8179 32.1284 58.4428 32.0176 59.0527H50.6283C50.5172 58.4428 50.5172 57.8179 50.6283 57.208H32.0176Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8682 19.3965H46.8569V26.7746H34.8682V19.3965Z",
    fill: "#D1DA5B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4246 45.2183L55.7735 41.5013C55.0309 39.838 53.3808 38.7658 51.5591 38.7627H50.5449V44.2961C50.5449 44.8049 50.9577 45.2183 51.4671 45.2183H57.4246Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3784 59.0527C64.8878 59.0527 65.3006 58.6396 65.3006 58.1302V57.208H61.5283C61.6394 57.8179 61.6394 58.4428 61.5283 59.0527H64.3784Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.501 28.6182H25.645V48.9072H15.501V28.6182Z",
    fill: "#D1DA5B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8682 28.6182H45.0125V48.9072H34.8682V28.6182Z",
    fill: "#D1DA5B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1777 17.5513H34.8668C36.9039 17.5513 38.5558 15.8997 38.5558 13.8626C38.5558 11.8255 36.9039 10.1738 34.8668 10.1738C32.8294 10.1738 31.1777 11.8255 31.1777 13.8626V17.5513Z",
    fill: "#D1DA5B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6562 19.3965H25.645V26.7746H13.6562V19.3965Z",
    fill: "#D1DA5B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4893 19.3965H33.0227V48.9076H27.4893V19.3965Z",
    fill: "#D1DA5B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8164 52.9203C63.5879 52.9203 62.592 51.9247 62.592 50.6962C62.592 49.715 63.2279 48.8841 64.1096 48.5885C63.2659 47.6534 62.0483 47.0627 60.6895 47.0627H51.4671C49.941 47.0576 48.7049 45.8219 48.7005 44.2961V38.7627H46.8561V50.7514H13.6562V55.362H21.7811C23.3034 52.7185 26.6801 51.8101 29.3236 53.3321C30.1674 53.8177 30.8676 54.5183 31.3535 55.362H46.8565H49.246H51.2922C52.8149 52.7185 56.1913 51.8101 58.8348 53.3321C59.6785 53.8177 60.3791 54.5183 60.865 55.362H65.3011V52.866C65.1448 52.9009 64.9831 52.9203 64.8164 52.9203Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7438 51.8763C65.4372 51.8763 65.9993 51.3142 65.9993 50.6208C65.9993 49.9274 65.4372 49.3652 64.7438 49.3652C64.0504 49.3652 63.4883 49.9274 63.4883 50.6208C63.4883 51.3142 64.0504 51.8763 64.7438 51.8763Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 40.039,
    y1: 4.44834,
    x2: 40.039,
    y2: 75.6277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B0F00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantagesIcon4);
export default __webpack_public_path__ + "static/media/advantages_icon_4.f1a35fc4464ecbe45f3f47e0f82eee62.svg";
export { ForwardRef as ReactComponent };